// extracted by mini-css-extract-plugin
export default {"contactBody":"contact_contactBody__oHCPo","contact_img":"contact_contact_img__+3iJO"};